module.exports = "/_next/static/images/andhra_front-2a7ff9f475335ba25f0e8660a0613c3b.jpg";